import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Table, CardFooter, FormGroup, Input } from 'reactstrap';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import { getErrorMessage } from 'helpers/errors';
import { getDebitos, Debitos as DebitosType, DebitosOptions } from 'features/insurers/insurersAPI';
import { fCurrency } from 'helpers/formatNumber';
import Pagination from 'components/Pagination';
import CollapsibleCard from '../../components/CollapsibleCard';

export default function Debitos() {
  const [showAlert, message, alert] = useAlert(false, '');
  const [data, setData] = useState<DebitosType>();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [terms, setTerms] = useState<DebitosType['terms']>([]);
  const [selectedTerm, setSelectedTerm] = useState<DebitosType['selectedTerm']>('');

  const [currentOptions, setCurrentOptions] = useState<DebitosOptions>({});

  useEffect(() => {
    getDebitos()
      .then(newData => {
        setData(newData);
        setTerms(newData.terms);
        setSelectedTerm(newData.selectedTerm);
        setCurrentPage(newData.pagination.current);
        setTotalPages(newData.pagination.total);
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudo obtener la información de los débitos');
      });
  }, []);

  const changePage = (newPage: number) => {
    const newOptions = {
      ...currentOptions,
      page: newPage,
    };

    setCurrentOptions(newOptions);

    getDebitos(newOptions)
      .then(newData => {
        setData(newData);
        setTerms(newData.terms);
        setSelectedTerm(newData.selectedTerm);
        setCurrentPage(newData.pagination.current);
        setTotalPages(newData.pagination.total);
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudo obtener la información de los débitos');
      });
  };

  const changeTerm = (newTerm: string) => {
    const newOptions = {
      ...currentOptions,
      page: 1,
      term: newTerm,
    };

    setCurrentOptions(newOptions);

    getDebitos(newOptions)
      .then(newData => {
        setData(newData);
        setTerms(newData.terms);
        setSelectedTerm(newData.selectedTerm);
        setCurrentPage(newData.pagination.current);
        setTotalPages(newData.pagination.total);
      })
      .catch(err => {
        alert(true, getErrorMessage(err) || 'No se pudo obtener la información de débitos');
      });
  };

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <CollapsibleCard title="Filtros">
            <Row>
              <Col md="3">
                <FormGroup>
                  <label>Periodo</label>
                  <Input type="select" onChange={ event => changeTerm(event.target.value) } value={ selectedTerm }>
                    {
                      terms.map(term => <option key={ term } value={ term }>{ term }</option>)
                    }
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          </CollapsibleCard>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>Débitos</Col>
                <Col md={4} className="text-right">
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>Obra Social</th>
                    <th>Remito</th>
                    <th>Periodo</th>
                    <th>Afiliado</th>
                    <th>Motivo</th>
                    <th>Documentación</th>
                    <th style={{ textAlign: 'right' }}>Importe Facturado</th>
                    <th style={{ textAlign: 'right' }}>Coseguro</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    data?.data.map((row, idx) => (
                      <tr key={idx}>
                        <td>{ row.obraSocial }</td>
                        <td>{ row.remito }</td>
                        <td>{ row.mesPrestacion }</td>
                        <td>{ row.afiliado }</td>
                        <td>{ row.motivo }</td>
                        <td>{ row.documentacion }</td>
                        <td style={{ textAlign: 'right' }}>{ fCurrency(row.importe) }</td>
                        <td style={{ textAlign: 'right' }}>{ fCurrency(row.coseguro) }</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
            <CardFooter>
              <Pagination
                page={ currentPage }
                pages={ totalPages }
                onChangePage={ changePage }
              />
            </CardFooter>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
